import { render, staticRenderFns } from "./CapabilityCard.vue?vue&type=template&id=27c2b2c9&scoped=true"
import script from "./CapabilityCard.vue?vue&type=script&lang=js"
export * from "./CapabilityCard.vue?vue&type=script&lang=js"
import style0 from "./CapabilityCard.vue?vue&type=style&index=0&id=27c2b2c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2b2c9",
  null
  
)

export default component.exports